import React from 'react'
import PropTypes from 'prop-types'
import TextInput from './TextInput'

const ICON_CLASSES = 'fas fa-search tw:absolute tw:right-3 tw:top-1/2 tw:-translate-y-1/2 '
  + 'tw:pointer-events-none tw:text-gray-500 tw:text-base!'

const SearchInput = ({ className = '', name, onChange, placeholder = '', value = '' }) => (
  <div className={`tw:relative ${className}`.trim()}>
    <TextInput
      className="tw:pr-8! tw:h-auto! tw:py-2.5! tw:text-sm! tw:leading-normal! tw:focus:border-ds-primary!"
      name={name}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
    />
    <i className={ICON_CLASSES} />
  </div>
)

SearchInput.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string
}

SearchInput.defaultProps = {
  className: '',
  placeholder: '',
  value: ''
}

export default SearchInput
